import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';

const OperationsEmptyState = ({
    message = 'Aucune donnée disponible',
    subMessage,
    compact = false,
}) => (
    <div className={`ops-state${compact ? ' ops-state--compact' : ''}`}>
        <FiCheckCircle className="ops-state__icon ops-state__icon--success" aria-hidden="true" />
        <p className="ops-state__title">{message}</p>
        {subMessage && <p className="ops-state__text">{subMessage}</p>}
    </div>
);

export default OperationsEmptyState;
